import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';
import { ICountryPhoneNumber, phoneNumbers } from './def';
import { EAppIcons, EAppIconsStandard } from 'src/app/classes/def/app/icons';

@Component({
  selector: 'phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss'],
})
export class PhoneNumberComponent implements OnInit {

  appIcons = EAppIcons;
  appIconsStandard = EAppIconsStandard;

  @Input() tel: string = '';
  @Output() valid = new EventEmitter<boolean>();

  @Output() onType = new EventEmitter<string>();

  phoneNumbers = phoneNumbers;
  selectedCountry: ICountryPhoneNumber = null;
  selectedCountryCode: string = null;

  loaded: boolean = false;

  ngOnInit() {
    setTimeout(() => {
      this.loaded = true;
    }, 100);
  }

  /** When selecting country from dropdown */
  selectCountry(item: ICountryPhoneNumber) {
    console.log("select country: ", item);
    this.selectedCountry = item;
    if (!this.tel) {
      this.tel = "";
    }
    if (!this.tel.startsWith(item.code)) {
      // Keep local number, replace only prefix
      this.tel = item.code + ' ' + this.tel.replace(/^\+\d+\s*/, '');
    }
    this.validateNumber();
  }

  /** When selecting country from ion-selectable */
  selectCountryCode(event: any) {
    if (!event) {
      return;
    }
    let cc: string = event.value;
    console.log("select country code: ", cc);
    this.selectedCountry = phoneNumbers.find(p => p.code === cc);
    if (!this.tel) {
      this.tel = "";
    }
    if (!this.tel.startsWith(cc)) {
      // Keep local number, replace only prefix
      this.tel = cc + ' ' + this.tel.replace(/^\+\d+\s*/, '');
    }
    this.validateNumber();
  }

  /** When typing the number */
  onPhoneInput() {
    setTimeout(() => {
      console.log("on phone input: ", this.tel);

      if (!this.tel) {
        this.tel = "";
        this.onType.next(null);
      } else {
        this.onType.next(this.tel);
      }

      const match = this.phoneNumbers.find(p => this.tel.startsWith(p.code));
      if (match) {
        this.selectedCountry = match;
        this.selectedCountryCode = match.code;
      } else {
        this.selectedCountry = null;
        this.selectedCountryCode = null;
      }
      this.validateNumber();
    }, 1);
  }

  private validateNumber() {
    const parsed = parsePhoneNumberFromString(this.tel);
    console.log("validate number: ", this.tel);
    console.log("parsed: ", parsed);
    const isValid = parsed ? parsed.isValid() : false;
    if (parsed != null) {
      this.selectedCountry = phoneNumbers.find(p => p.code === parsed.country);
      console.log("selected country: ", this.selectedCountry);
      if (this.selectedCountry != null) {
        this.selectedCountryCode = parsed.country;
      }
    } else {
      this.selectedCountry = null;
      this.selectedCountryCode = null;
    }
    this.valid.emit(isValid);
  }
}
